<template>
    <div id="app">
      <!-- ... (the rest of the body content) ... -->
  
      <section class="section">
        <div class="madlibsflex">
          <div class="madlibscontainer has-text-centered">
            <h1 class="title is-3">
              My name is 
              <input type="text" v-model="prospectName" class="input " style="width: 10em" placeholder="Slim Shady"/>.
              I am
              <input type="number" v-model="age" class="input " style="width: 5em" placeholder="35" /> years old. I want to retire by age
              <input type="number" v-model="retirementAge" class="input" style="width: 5em" placeholder="75" />.
              <br>
              <br>
              <div class="buttons is-centered">
                <button class="button is-primary is-rounded" @click="nextStep">
                  <span>Continue</span>
                  <span class="icon"><i class="fas fa-arrow-right"></i></span>
                </button>
              </div>
            </h1>
          </div>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  import {Money} from 'v-money'

  export default {
    data() {
      return {
        prospectName: "",
        age: "",
        saving: 0,
        retirementAge: "",
        money: {
          decimal: '.',
          thousands: ',',
          prefix: '$',
          suffix: '',
          precision: 0,
          masked: false /* doesn't work with directive */
        }
      };
    },
    emits: ['nextStep'],
    components: {Money},
    methods: {
        nextStep() {
            this.$emit('nextStep', {
                module: 'input',
                prospectName: this.prospectName,
                age: this.age,
                saving: this.saving,
                retirementAge: this.retirementAge
            })
        }
    }
  };
  </script>
  
  <style scoped>
  /* Add your styles here */
  body {
    padding: 0.5em;
  }
  
  .rainbow {
    background: linear-gradient(
      to right,
      #ef5350,
      #f48fb1,
      #7e57c2,
      #2196f3,
      #26c6da,
      #43a047,
      #eeff41,
      #f9a825,
      #ff5722
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  
  h1 {
    margin-top: 0;
    font-family: "Inter", "Inter Variable", "Roboto", "Segoe UI", "Segoe UI Variable", "SF Pro", "Helvetica", "Arial", sans-serif;
    font-weight: 700;
    font-size: 6rem;
  }
  .input {
    font-family: "Inter", "Inter Variable", "Roboto", "Segoe UI", "Segoe UI Variable", "SF Pro", "Helvetica", "Arial", sans-serif;
    font-weight: 700;
  }
  
  .verticalflex {
    height: 70vh;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }
  
  .madlibsflex {
    display: flex;
    height: 70vh;
    justify-content: center;
    align-items: center;
  }
  
  .madlibscontainer {
    max-width: 55rem;
  }
  </style>
  